import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PersistentAlertComponent } from 'src/app/dialogs/alert/persistent-alert.component';
import Swal, { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private _matSnackBar = inject(MatSnackBar);
  private dialog = inject(MatDialog);


  public SwalMessage(icon: SweetAlertIcon, title: string, showConfirmButton = false, timer = 4000) {
    return Swal.fire({
      icon,
      title,
      heightAuto: false,
      showConfirmButton,
      timer,
    });
  }

  public dialogMessage(icon: SweetAlertIcon, title:string, options?:SweetAlertOptions) {
    return Swal.fire({
      icon,
      title,
      heightAuto: false,
      ...options
    })
  }

   /** Muestra un mensaje mediante un MatSnackBar de angular material */
  snackBarMessage( 
    message: string, 
    action: string, 
    configuration: { 
      duration?: number, 
      verticalPosition?: 'top' | 'bottom', 
      horizontalPosition?: 'center' | 'end' | 'left' | 'right' | 'start' } 
  ) {
    return this._matSnackBar.open( message, action, {
      duration: configuration.duration ?? 4000,
      verticalPosition: configuration.verticalPosition ?? 'bottom',
      horizontalPosition: configuration.horizontalPosition ?? 'center'
    });
  }

  /**
   * Muestra un mensaje de diálogo en una esquina
   * @param icon ïcono del Toast
   * @param title Titulo del Toast
   */
  swalToast(icon: SweetAlertIcon, title:string, options?:SweetAlertOptions) {
    Swal.fire({
      position: "top-end",
      heightAuto: false,
      title, icon, toast: true , ...options
    })
  }

  /**
   * Abre un diálogo persistente (solo cierra al hacer click en OK),
   * usando Angular Material Dialog + PersistentAlertComponent.
   */
  public showPersistentAlert(
    title: string,
    text: string,
    okText?: string
  ): void {
    this.dialog.open(PersistentAlertComponent, {
      data: { title, text, okText },
      disableClose: true,
      width: '400px'
    });
  }

  swalQuestion(title: string, text: string, confirmButtonText: string, cancelButtonText: string, icon: SweetAlertIcon = 'question') {
    return Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      heightAuto: false
    });
  }

  showError(message: string) {
    this.SwalMessage('error', message, true);
  }

  showSuccess(message: string) {
    this.SwalMessage('success', message, true);
  }

  showWarning(message: string) {
    this.SwalMessage('warning', message, true);
  }

}